export default {"src":"/_next/static/media/arrow-right-btn.ca588339.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};